import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  messagePaneRoot: { width: "100%", position: "absolute", bottom: 0 },
  messageBubbleContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: 15,
    "& button": {
      outline: "0 !important"
    }
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2
    }
  },
  "input:hover ~ &": {
    backgroundColor: "#ebf1f5"
  },
  "input:disabled ~ &": {
    boxShadow: "none",
    background: "rgba(206,217,224,.5)"
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3"
    }
  },
  botText: {
    padding: 15,
    backgroundColor: "#8fccc1",
    marginLeft: "auto",
    maxWidth: "70%",
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    color: "#383838",
    whiteSpace: "pre-line"
  },
  userText: {
    padding: 12,
    maxWidth: "70%",
    backgroundColor: "#e8e8e8",
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
    color: "#383838",
    borderBottomRightRadius: 15,
    whiteSpace: "pre-line"
  },
  messageType: {
    fontSize: "15px"
  },
  messageTypeData: {
    color: "grey",
    fontSize: "10px"
  },
  messageBubbleMain: {
    display: "flex",
    maxWidth: "100%"
  },
  messageBubbleImg: {
    height: "30px",
    width: "30px",
    marginRight: "5px",
    marginTop: "5px"
  },
  messageTextMain: {
    display: "flex"
  },
  messageTextType: {
    fontSize: "15px"
  },
  messageActionColor: {
    color: "blue"
  },
  messageColorMain: {
    color: "#3eb2a1"
  },
  tagData: {
    marginRight: "3px"
  },
  artistData: {
    display: "inline-block",
    cursor: "pointer"
  },
  timestamp: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: -15
  },
  timestampType: {
    color: "#5f5f5f",
    fontSize: "10px",
    marginTop: "10px"
  },
  messageActions: {
    padding: 15
  },
  messageActionsAction: {
    marginLeft: 10,
    padding: 10
  },
  inputTextField: {
    height: 50,
    margin: 10,
    width: "95%"
  },
  FontMain: {
    fontSize: `${localStorage.getItem("Fontsize")}px`
  },
  singleHeb: {
    // fontSize: `${localStorage.getItem("Fontsize")}px`,
    textAlign: "right",
    color: "black"
  },
  maltiHeb: {
    textAlign: "right",
    // fontSize: "18px",
    fontSize: `${localStorage.getItem("Fontsize")}px`,
    color: "black",
    marginLeft: "4px"
  },
  setDatalast: {
    fontSize: `${localStorage.getItem("Fontsize")}px`,
    marginLeft: "4px"
  },
  nested: {
    paddingLeft: theme.spacing(4)
  },
  slider: {
    padding: "22px 0px"
  },
  sliderRoot: {
    width: 300
  },
  posData: {
    display: "inline-block",
    cursor: "pointer"
  },
  chatactionmain: {
    minWidth: "300px"
  },
  chataction: {
    marginLeft: 10,
    marginRight: 25
  },
  chatAction: {
    marginBottom: 10
  },
  chatTagLabel: {
    paddingLeft: "20px",
    textTransform: "capitalize",
    fontWeight: 500
  },
  chatTagMain: {
    marginBottom: "2.70em"
  },
  card: {
    minWidth: "95%"
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  }
}));

export default useStyles;
